var map = {
  "./da.json": [
    "88328",
    [
      43441
    ]
  ],
  "./fi.json": [
    "76346",
    [
      21895
    ]
  ],
  "./sv.json": [
    "60058",
    [
      5415
    ]
  ],
  "./ja.json": [
    "80830",
    [
      43923
    ]
  ],
  "./lt.json": [
    "79455",
    [
      11508
    ]
  ],
  "./sl.json": [
    "99648",
    [
      28569
    ]
  ],
  "./fr.json": [
    "16355",
    [
      99360
    ]
  ],
  "./es.json": [
    "91831",
    [
      68764
    ]
  ],
  "./no.json": [
    "71327",
    [
      53885
    ]
  ],
  "./cs.json": [
    "84961",
    [
      91162
    ]
  ],
  "./en.json": [
    "56512",
    [
      89561
    ]
  ],
  "./description/en.json": [
    "61183",
    [
      67540
    ]
  ],
  "./pl.json": [
    "63163",
    [
      96360
    ]
  ],
  "./hu.json": [
    "95096",
    [
      96161
    ]
  ],
  "./nl.json": [
    "48217",
    [
      13826
    ]
  ],
  "./de.json": [
    "43524",
    [
      93829
    ]
  ],
  "./pt.json": [
    "56480",
    [
      37296
    ]
  ],
  "./it.json": [
    "46494",
    [
      44883
    ]
  ],
  "./et.json": [
    "19629",
    [
      39207
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 71794;
module.exports = __rspack_async_context;
